import { Config } from 'driver.js';

export const oofTourConfig: Config = {
  showProgress: true,
  popoverClass: 'tour-guide-theme',
  nextBtnText: 'Next',
  prevBtnText: 'Previous',
  doneBtnText: 'Done',
  overlayColor: 'rgba(0, 0, 0, 0.6)',
  disableActiveInteraction: true,
  steps: [
    {
      popover: {
        title: 'Online Orders',
        description:
          'Welcome to your online orders. Here you can configure and submit your orders. You can also monitor the status of all current and past orders.',
        side: 'right',
        align: 'start',
        onNextClick: () => {
          (document.querySelector('.btn-close-icon') as HTMLButtonElement)?.click();
        },
      },
    },
    {
      element: '[app-tour-guide="payment"]',
      popover: {
        title: 'Addresses / Payment',
        description:
          'Here you can enter the invoice and delivery address as well as payment details. This information is required to submit an order / order item.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: '[app-tour-guide="order-details"]',
      popover: {
        title: 'Order Details',
        description:
          'Here you can see the amount and details of your products listed in the offer.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: '[app-tour-guide="configure-order-item"]',
      popover: {
        title: 'Order Item Configuration',
        description: 'Start here the configuration of your order / order item',
        side: 'bottom',
        align: 'start',
        onNextClick: () => {
          (
            document.querySelector('[app-tour-guide="configure-order-item"]') as HTMLButtonElement
          )?.click();
        },
      },
    },
    {
      element: '[app-tour-guide="create-new-config-btn"]',
      popover: {
        title: 'New Configuration',
        description: 'Create a new configuration',
        side: 'bottom',
        align: 'start',
        onNextClick: () => {
          (
            document.querySelector('[app-tour-guide="create-new-config-btn"]') as HTMLButtonElement
          )?.click();
        },
      },
    },
    {
      element: '[app-tour-guide="new-config-dialog"]',
      popover: {
        title: 'New Configuration',
        description: `One configuration may contain different VHF frequencies, belt colors and/or belt labels, for all other variations use multiple configurations.
        <br />
        Please choose a descriptive name (e.g. project name, animal species / sex, project area etc.) for the configuration in favor for a clear documentation.`,
        side: 'top',
        align: 'start',
        onNextClick: () => {
          (document.querySelector('.btn-close-icon') as HTMLButtonElement)?.click();
        },
      },
    },
  ],
};
